<template>
  <v-card v-if="vehicle != null">
    <ODialogBar no-close title="Configurações Gerais">
      <v-spacer />
      <v-btn icon @click="startEdit">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </ODialogBar>
    <v-card-text class="pa-4 d-flex flex-row flex-wrap">
      <EditDetailsDialog ref="editDialog" />
      <OCapCont class="w-1/2 pa-2" label="Placa">
        {{ vehicle.code || '─' }}
      </OCapCont>

      <OCapCont class="w-1/2 pa-2" label="Código Auxiliar">
        {{ vehicle.extraCode || '─' }}
      </OCapCont>

      <OCapCont class="w-1/2 pa-2" label="Marca/Modelo">
        {{ (vehicle.brandModel && vehicle.brandModel.name) || '─' }}
      </OCapCont>

      <OCapCont class="w-1/2 pa-2" label="Grupo">
        {{ vehicle.group || '─' }}
      </OCapCont>

      <OCapCont class="w-full pa-2" label="Tags">
        <OTagList :value="vehicle.tags" />
      </OCapCont>

      <OCapCont class="w-full pa-2" label="Descrição">
        {{ vehicle.description || '─' }}
      </OCapCont>
    </v-card-text>

    <v-divider />

    <v-card-text class="d-flex flex-wrap pa-3">
      <OCapCont class="col-6" label="Criado em">
        {{ vehicle.createdAt | moment('DD/MMM/YYYY HH:mm:ss') }}
      </OCapCont>

      <OCapCont class="col-6" label="Atualizado em">
        {{ vehicle.updatedAt | moment('DD/MMM/YYYY HH:mm:ss') }}
      </OCapCont>
    </v-card-text>
  </v-card>
</template>

<script>
import EditDetailsDialog from './EditDetailsDialog.vue'

export default {
  components: { EditDetailsDialog },
  props: {
    vehicle: { required: true }
  },
  data() {
    return { isLoading: false }
  },
  methods: {
    async startEdit() {
      let res = await this.$refs.editDialog.open(this.vehicle.id)
      if (res === true) {
        this.$emit('reload')
      }
    }
  }
}
</script>

<style lang="sass">
.input-border-bottom
  padding-bottom: 4px
  border-bottom: 1px solid rgba(0, 0, 0, 0.42)

.transition-quick
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.hover-bg-grey:hover
  background-color: rgba(0,0,0,.05)
</style>
